import { Routes, Route } from 'react-router-dom'
import ProtectedRoute from '@/core/routes/protected'
import UnProtectedRoute from '@/core/routes/unprotected'
import AppLayout from '@/layouts/AppLayout'
import AuthLayout from '@/layouts/AuthLayout'
import WelcomeLayout from '@/layouts/WelcomeLayout'
import LegalLayout from '@/layouts/LegalLayout'

// Lazy load pages for better performance
import { lazy, Suspense } from 'react'
import Loading from '@/core/components/globals/loading'

const Index = lazy(() => import('@/pages/Index'))
const NotFound = lazy(() => import('@/pages/NotFound'))

function App() {
  return (
    <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Loading /></div>}>
      <Routes>
        {/* Auth routes */}
        <Route path="/auth/*" element={<UnProtectedRoute><AuthLayout /></UnProtectedRoute>} />
        
        {/* Welcome routes */}
        <Route path="/welcome/*" element={<ProtectedRoute><WelcomeLayout /></ProtectedRoute>} />
        
        {/* Legal routes */}
        <Route path="/legal/*" element={<ProtectedRoute><LegalLayout /></ProtectedRoute>} />
        
        {/* Protected app routes */}
        <Route path="/*" element={<ProtectedRoute><AppLayout /></ProtectedRoute>} />
        
        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}

export default App
